import React, { useState } from 'react';
import { cn } from '../../utils';

const DropdownMenu = ({ children }) => {
  const [open, setOpen] = useState(false);
  
  return (
    <div className="relative inline-block text-left">
      {React.Children.map(children, child => 
        React.cloneElement(child, { open, setOpen })
      )}
    </div>
  );
};

const DropdownMenuTrigger = ({ children, open, setOpen, asChild, className, ...props }) => {
  const Child = asChild ? React.Children.only(children) : 'button';
  
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      onClick: () => setOpen(!open),
      ...props
    });
  }
  
  return (
    <button
      className={cn("inline-flex items-center justify-center", className)}
      onClick={() => setOpen(!open)}
      {...props}
    >
      {children}
    </button>
  );
};

const DropdownMenuContent = ({ children, open, setOpen, className, ...props }) => {
  if (!open) return null;
  
  return (
    <div 
      className={cn(
        "absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50",
        className
      )}
      {...props}
    >
      <div className="py-1">
        {children}
      </div>
    </div>
  );
};

const DropdownMenuItem = ({ children, className, onClick, asChild, ...props }) => {
  const Child = asChild ? React.Children.only(children) : 'button';
  
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      className: cn("block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100", className),
      onClick: (e) => {
        onClick?.(e);
      },
      ...props
    });
  }
  
  return (
    <button
      className={cn(
        "block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100",
        className
      )}
      onClick={(e) => {
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export { 
  DropdownMenu, 
  DropdownMenuTrigger, 
  DropdownMenuContent, 
  DropdownMenuItem 
};
